import { all } from "redux-saga/effects";

import notificationSaga from './saga';

export default function* rootSaga(getState) {
  yield all([
    ...notificationSaga,
  ]);
}
